module.exports = __webpack_public_path__ + "img/rapidhealth.13194fc2.svg";